import React from 'react';

import { Route } from 'react-router-dom';

import { RouteWithSubRoutesProps } from './RouteWithSubRoutes.props';

const getRoute = (props: RouteWithSubRoutesProps): JSX.Element => {
  const { routes = {}, ...route } = props;
  return (
    <Route {...route}>
      {Object.values(routes).map((subRoute) => getRoute(subRoute))}
    </Route>
  );
};

export default getRoute;
